/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CacheService } from './global/ng2-cache/services/cache.service';

import { AuthService } from './services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    private authService: AuthService,
    private cacheService: CacheService) {

  }

  async canActivate(route: ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    const permissionCheck = await this.authService.hasPermission(route.data['role'] || 'public')
    if (permissionCheck) {
      // if the user has permission
      // AND the account is not active
      // AND the user is not >sAdmin
      // then show a special view
      if (route.data.title != 'Account Suspended' && route.data.title != 'Log out') { //don't bother checking the suspended page
        let accountStatus = this.cacheService.get('session') ? this.cacheService.get('session').account_status : null;
        if (accountStatus) {
          const isSAdmin = await this.authService.hasPermission('sadmin')

          if (accountStatus != 'active' && !isSAdmin) {
            this.router.navigate(['/suspended']);
          }
        }
      }

      return true;
    }
    else {
      if (!this.authService.isLoggedIn) {
        this.authService.setRedirectUrl(state.url);
        this.router.navigate(['/login']);
        return false;
      }
      else {
        // Accounts for a race condition where session isn't ready yet and auth guard rejects
        if (route.data.title == 'Dashboard') {
          return true;
        }
        else {
          this.router.navigate(['/']);
          return false;
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/auth.guard.ts